import React, {useState, useEffect} from "react";
import { useForm, Controller, control, NavLink } from "react-hook-form";
import Select, { StylesConfig }  from "react-select";
import {Input, Button, Box, Stack, AppBar, styled, Toolbar,Typography, InputBase,Avatar } from "@mui/material";
import { theme, Badge, } from "@material-ui/core";
import  HomeOutlinedIcon  from "@mui/icons-material/HomeOutlined";
import chroma from 'chroma-js';


import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../../components/Header.jsx";
//import sendDataToAPI from '../../methods/sendDataToAPIs.jsx';

import { DatePicker, Space } from 'antd';
import Contacts from "../../scenes/contacts/index.jsx";
//import TableCMAA from "../form/TableCMAA.jsx";
import TableXDataGrid from "../form/TableXDataGrid.jsx";
import { ColorModeContext } from "../../theme.js";
import ImageFiller from "react-image-filler";
//import CMMForm from "../form/CMMForm.jsx";
//import FormAXIOS from "../form/FormAXIOS.jsx";
import RegisterProjectCategoryForm from "../form/ProjectCategory/RegisterProjectCategoryForm.jsx";
//import FRMAXIOSEDIT from "../form/FRMAXIOSEDIT.jsx";
import PCEditModal from "../form/PCEditModal.jsx";
import FRMNewProject from "../form/FRMNewProject.jsx";
//import Modal from 'react-bootstrap/Modal';
import { API_URL, URL as MYURL, ProjectCategoryRecordsUrl } from "../form/constants";
//import Axntd from "./axntd.jsx";
import ProjectCategoryModal from "./ProjectCategory/ProjectCategoryModal.jsx";
import EditProjectCategoryForm from "./ProjectCategory/EditProjectCategoryForm.jsx";

export default function ProjectCategoryContainer(props) {
     
    const colourStyles = {
      control: styles => ({ ...styles, backgroundColor: "white" }),
      option: (styles, { data, isDisabled, isFocused, isSelected }) => {
        const color = chroma(ColorModeContext.color)
        return {
          ...styles,
          backgroundColor: isDisabled
            ? undefined
            : isSelected
            ? data.color
            : isFocused
            ? color.alpha(0.1).css()
            : undefined,
          color: isDisabled
            ? "#ccc"
            : isSelected
            ? chroma.contrast(color, "white") > 2
              ? "white"
              : "black"
            : data.color,
          cursor: isDisabled ? "not-allowed" : "default",
    
          ":active": {
            ...styles[":active"],
            backgroundColor: !isDisabled
              ? isSelected
                ? data.color
                : color.alpha(0.3).css()
              : undefined
          }
        }
      },
      input: styles => ({ ...styles, ...dot() }),
      placeholder: styles => ({ ...styles, ...dot("#ccc") }),
      singleValue: (styles, { data }) => ({ ...styles, ...dot(data.color) })
    }
    
    //
    const [patientDOB, setPatientDOB]=useState('');
    //
    const dot = (color = 'transparent') => ({
      alignItems: 'center',
      display: 'flex',
    
      ':before': {
        backgroundColor: color,
        borderRadius: 10,
        content: '" "',
        display: 'block',
        marginRight: 8,
        height: 10,
        width: 10,
      },
    });

    
   
    
    //
    const [onOpenStatus, setOnOpenStatus]=useState(false);
    
    const OnOpenStatusToTrue=()=>{
      setOnOpenStatus(true);
      console.log("OUT");
    }
    // new start

    const [open, setOpen] = React.useState(false);
 
    const handleClose = () => {
        setOpen(false);
    };
    
    const handleOpen = () => {
        setOpen(true);
    };
    // new end
    useEffect(()=>{
     if(onOpenStatus===true){
       //kaunda
       console.log("QWE onOpenStatus=" + onOpenStatus)
     }
     else{
      console.log("QWE onOpenStatus=" + onOpenStatus)
     }
    },[onOpenStatus])
     //
    const renderDetailsButton = (params) =>{
      return
      (
        <strong>
        
          <Button
          onClick={()=>{
            alert("")
          }}
          >
            EDIT
          </Button>
        </strong>
      )
    }
    //

    useEffect(()=>{
      console.log(" XYXY onOpenStatus=" + onOpenStatus)
    }, [onOpenStatus])
    
    //const tableXDataGridColumns =[
     const tableXDataGridColumns =[
        {
          field: '',
          headerName: 'ID',
          flex: 1,
          cellClassName: 'name-column--cell',
          type: 'number',
          align: 'left',
          //renderCell:(index) => index.api.getRowIndex(index.row.code)
          /***/
          renderCell: (index) =>{
            console.log(index)
            //index.api.getRowIndexRelativeToVisibleRows(index.row.code) + 1
             }
        /***/
          
      },
      {
        field: 'service_category_name',
        headerName: 'Service Category Name',
        flex: 1,
        cellClassName: 'name-column--cell',
        type: 'string',
        align: 'center'
      },
      {
        field: 'project_category',
        headerName: 'Project Category Name',
        flex: 1,
        cellClassName: 'name-column--cell',
        type: 'string',
        align: 'center'
      },
    {
      field: 'pic_intro',
      headerName: 'Pic Intro',
      flex: 1,
      cellClassName: 'name-column--cell',
      type: 'string',
      align: 'left'
  },
  {
    field: 'intro_txt',
    headerName: 'Web Intro',
    flex: 1,
    cellClassName: 'name-column--cell',
    type: 'string',
    align: 'left'
  },
  /**
  {
  field: 'creation_date',
  headerName: 'Date Created',
  flex: 1,
  cellClassName: 'name-column--cell',
  type: 'string',
  align: 'left'
  },
  **/
      {
        field: 'img',
        headerName: 'IMAGE',
        flex: 3,
        cellClassName: 'name-column--cell',
        type: 'img',
        align: 'left',
        renderCell: (params)=>{
          return (
            <div>
              <img  src={"../../../../../static/media/" + params.value}
              sx={{
                height: "190px",
                width: "190px"
              }} 
              onClick={(e)=>{
                setOnOpenStatus(true);
                console.log("img QQQ =" + params.value);
                OnOpenStatusToTrue();
                console.log("IN onOpenStatus=" + onOpenStatus);
              }}
              />
            </div>
          )
        }
        },
        {
          field: 'id',
          headerName: 'Edit',
          flex: 1,
          cellClassName: 'name-column--cell',
          type: 'string',
          align: 'left',
          renderCell: (params)=>{
            const onClickButton = e => {
              e.stopPropagation(); // don't select this row after clicking
              console.log("params.value)=" + params.value);
              setOnOpenStatus(prev => false);
              console.log("YU params.value=" + params.value);
              setOnOpenStatus(prev => true);
              console.log("YU params.value=" + params.value);
            }      
            return(
            <Button color="secondary" variant="contained" onClick={handleOpen}>
              Edit
            </Button>)
          }
          },   

     ]
    
   
    //
    const onChangeDate = (date, dateString) => {
  
      console.log("date=" + date);
      console.log("dateString=" + dateString);
      console.log(date, dateString);
      setPatientDOB(dateString);
      console.log("PatientDOB=" + patientDOB);
  };
    //
    
    //
   
    const onSubmit = (data) => { 
     
      try {
               
          }
     catch(err) {
     console.log(err.message);
       }
    }
     
    
    
    
    const onOptionChangeHandler = (event) => {
      console.log("User Selected Value - ", event.target.value);
    }
    
    
   
    const node = document.querySelector("#app");

    const changeDate = (jsDate, dateString) => {
      // ...
    };
    
    const onChangeDOB = (date, dateString) => {
      console.log(date, dateString)
      setPatientDOB(dateString)
      console.log("pdob=" + patientDOB)
    };
    

    const tOPButtonOnClick = () =>{
       if(showForm==true){
        setShowForm(false)
        setTopButtonLabel('Show Records')
       }
       else{
        setShowForm(true)
        setTopButtonLabel('Show Form')
       }
    }
    const [showForm, setShowForm] = useState(true);
    
    const [ShowTableXDataGrid, setShowTableXDataGrid] = useState(false);
    //TableXDataGrid

    const [showFormEdit, setShowFormEdit] = useState(false);

    const [topButtonLabel, setTopButtonLabel]=useState('Show Records');
    

    const tOPButtonTOnClick = () =>{
      if(showFormT==true){
       setShowFormT(false)
       ShowTableXDataGrid(false)
       setTopButtonLabelT('Show Records')
      }
      else{
       setShowFormT(true)
       ShowTableXDataGrid(true)
       setTopButtonLabelT('Show Form')
      }
   }
    const [showFormT, setShowFormT] = useState(true);
    const [topButtonLabelT, setTopButtonLabelT]=useState('Show FORM T');
    
    const [ButtonShowFormFPCL, setButtonShowFormFPCL]=useState("NEW PROJECT");
    const [ShowFormFPCL, setShowFormFPCL ]=useState(false);
    const handleButtonShowFormFPCL=()=>{
      
      console.log("ShowFormFPCL=" + ShowFormFPCL);

      if(ShowFormFPCL==true){
          //setShowFormFPCL(true); showForm ShowTableXDataGrid
          setButtonShowFormFPCL("SHOW DATA SHEET");
          setShowFormFPCL(false)
          setShowForm(true);
          //ShowTableXDataGrid(true)
      }
      else{
          //setShowFormFPCL(false);
          setButtonShowFormFPCL("NEW PROJECT");
          setShowFormFPCL(true)
          setShowForm(false);
          ShowTableXDataGrid(false)

      }
    }

  
    return (
      <Box m="20px" onTouchStart={()=>{
      setOnOpenStatus(false)
      console.log("ASDEWQ")}
      }>
      
      {/** <Button>RECORDS</Button> **/}
      
      <Button type="submit" color="secondary" variant="contained"
      onClick={tOPButtonOnClick}
      >
        {topButtonLabelT}
      </Button>

      <Button type="submit" color="secondary" variant="contained"
      onClick={handleButtonShowFormFPCL}
      >
        {ButtonShowFormFPCL}
      </Button>
      {/**/}
      <span>
      </span>
      <br/>

      {ShowFormFPCL && (
        <FRMNewProject />
      )}
      
      {!showForm && (
      <div style={{height: '1200px'}}>
        <br/>
        <TableXDataGrid rowHeightP={200} url={ProjectCategoryRecordsUrl} tableColumns={tableXDataGridColumns}></TableXDataGrid>
      </div>
      )}
      
      {showForm && (
        <div style={{height: '1200px'}}>
           <Header title="CREATE PROJECT CATEGORY" subtitle="Create a New Project Category" />
      <RegisterProjectCategoryForm />
      </div>
      )}
      
      {showFormEdit && (
        <div style={{height: '1200px'}}>
           <Header title="UPDATE PROJECT CATEGORY" subtitle="Create a New Project Category" />
        

      </div>
      )}
      
      {/***
      {onOpenStatus === true &&
      (
      <PCEditModal
      onOpenStatusAtr={onOpenStatus}
      />
      )
      }
      ***/}
      {/***
     <button type="button" onClick={handleOpen}>
                Click Me to Open Modal
      </button>
      ***/}
     <ProjectCategoryModal isOpen={open} onClose={handleClose} width={400} height={650}>
        <EditProjectCategoryForm />
     </ProjectCategoryModal>

      </Box>
      
    )
  }